import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import useStore from '../../Store/Store';
import SignUpOnboardingStep from './SignUpOnboardingStep';
import Logo from '../../images/logo.png';
import { InputBase, Paper } from '@mui/material';
import { styled } from '@mui/system';
import inputValidationService from '../../input-validation.service';
import { isEmpty } from 'lodash';
import { inviteCareRecipient } from '../../utils/api';
import { useMutation } from 'react-query';
import Button from '../../components/Button';

const CustomInput = styled(InputBase)(({ theme }) => ({
  borderRadius: '100px',
  border: `1px solid black`,
  padding: theme.spacing(1, 2),
  width: '100%',
}));

const CustomPaper = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  borderRadius: '22px',
  padding: theme.spacing(2),
  backgroundColor: '#f5f5f7',
}));

const InviteCareRecipients = ({ handleBackStep, handleNextStep }) => {
  const width = useStore((state) => state.screenWidth);
  const [input, setInput] = React.useState('');
  const [error, setError] = React.useState('');
  const [email, setEmail] = React.useState('');

  const inviteCareRecipientHandler = useMutation(inviteCareRecipient, {
    onSuccess: async ({ data }) => {
      console.log('data =====> ', data);
    },
    onError: (error) => {
      console.log('error =====> ', error);
      if (error?.response?.status === 400) {
        return setError(error?.response?.data?.data?.join(',') || 'Something went wrong!');
      } else {
        return setError(error?.response?.data?.message || 'Something went wrong!');
      }
    },
  });

  const handleSubmitInvite = (e) => {
    if (e.key === 'Enter') {
      if (isEmpty(input.trim())) {
        return setError('Input cannot be empty!');
      }

      if (!inputValidationService.email(input) && !inputValidationService.validatePhoneNumber(input)) {
        return setError('Enter a valid email or phone number!');
      }
      setError('');

      setEmail(input);
    }
  };

  const handleInviteUser = () => {
    let userEmail = '';
    let phoneNo = '';

    if (inputValidationService.email(input)) {
      userEmail = input;
    }
    if (inputValidationService.validatePhoneNumber(input)) {
      phoneNo = input;
    }

    inviteCareRecipientHandler.mutate({ email: userEmail, phoneNo });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: width > 1050 ? '50%' : '100%',
        padding: '1rem',
      }}
    >
      <Box
        component="img"
        sx={{ width: '55px', height: '37.56px', marginBottom: '2rem' }}
        alt="Mask group"
        src={Logo}
      />
      <div style={{ paddingInline: '4rem', paddingBlock: '5rem' }}>
        <SignUpOnboardingStep step={3} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 'medium', color: 'rgba(29, 29, 31, 1)' }}>
            Add your Care recipients
          </Typography>
        </Box>

        <Grid container direction="column" spacing={3} mt={2}>
          <Grid item>
            <Typography variant="body1" color="textSecondary">
              Invite Care recipients via email or phone
            </Typography>
            <CustomInput
              placeholder="Invite Care recipients by email or phone, enter to add"
              onChange={(e) => setInput(e.target.value)}
              value={input}
              onKeyPress={handleSubmitInvite}
            />
            {!isEmpty(error) && <span style={{ color: 'red' }}>{error}</span>}
          </Grid>
          {!isEmpty(email) && (
            <Grid item>
              <CustomPaper>
                <Grid container justifyContent="space-between" alignItems="center">
                  <Typography variant="h6" color="textPrimary">
                    {email}
                  </Typography>
                  <Button text="Send Invite" onClick={handleInviteUser} />
                </Grid>
              </CustomPaper>
            </Grid>
          )}
          {/* <Grid item>
            <Divider sx={{ marginY: '1rem', color: 'grey' }}>or</Divider>
          </Grid>
          <Grid item>
            <Typography variant="body1" color="textPrimary">
              Add Care recipients via CAN Go
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Press the flashlight button for 10 seconds on your smart cane to show the cane PIN number or check your
              email for the letter with the PIN number.
            </Typography>
          </Grid>
          <Grid item>
            <Grid container spacing={2}>
              <Grid item xs>
                <CustomInput placeholder="Enter PIN here" />
              </Grid>
              <Grid item>
                <CustomButton variant="outlined" color="inherit">
                  Add
                </CustomButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <CustomPaper>
              <Grid container justifyContent="space-between" alignItems="center">
                <Grid item>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <Box
                        sx={{
                          width: 60,
                          height: 60,
                          borderRadius: '12px',
                          overflow: 'hidden',
                        }}
                      >
                        <img src={CAN} alt="Cane black" width={60} height={60} />
                      </Box>
                    </Grid>
                    <Grid item>
                      <Typography variant="h6" color="textPrimary">
                        CAN Go
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <CustomButton variant="contained" style={{ background: '#01796b' }}>
                    Add Device
                  </CustomButton>
                </Grid>
              </Grid>
            </CustomPaper>
          </Grid> */}
        </Grid>

        <Box sx={{ display: 'flex', gap: 6, marginTop: '40px' }}>
          <Button text="Back" bg="light" onClick={handleBackStep} fullWidth />
          <Button text="Skip" bg="light" onClick={handleNextStep} fullWidth />
          <Button text="Submit" onClick={handleNextStep} fullWidth />
        </Box>
      </div>
    </Box>
  );
};
export default InviteCareRecipients;
